import { daysInMonth } from '.';

export const dateExists = (year: number, month: number, day: number) =>
  month >= 1 && month <= 12 && day > 0 && day <= daysInMonth(month, year);
